import { HeartOutlined } from "@ant-design/icons";
import { Avatar, Button, Flex, Typography, theme } from "antd";
import { useEffect, useState } from "react";
import { TInterest } from "../../models/interests.model";
import { useTheme } from "../../providers/ThemeProvider";
import { TResponse } from "../../services/apiWorker";
import { getInterests } from "../../services/interests.service";
import { deepCopy } from "../../utils/deepCopy";
const { Text, Title, Link } = Typography;
const { useToken } = theme;

export function AccountSetupInterest({
  steps,
  currentStep,
  setCurrentStep,
  onComplete,
  metadata,
  setMetadata,
  isUpdating,
}: {
  steps: number;
  currentStep: number;
  setCurrentStep: (data: number) => void;
  onComplete: () => void;

  metadata: { [key: string]: any };
  setMetadata: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;

  isUpdating: boolean;
}) {
  const { message } = useTheme();
  const { token } = useToken();
  const [interests, setInterests] = useState<TResponse<TInterest>>({
    content: [],
    limit: 0,
    offset: 0,
    total: 0,
  });

  useEffect(() => {
    getInterests({
      onSuccess: setInterests,
    });
  }, []);

  return (
    <Flex
      style={{
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Flex
        style={{
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "320px",
        }}
      >
        <Avatar shape="square" size={64} icon={<HeartOutlined />} />

        <Text
          style={{
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            marginBottom: token.marginMD,
            fontSize: token.fontSizeHeading3,
            marginTop: "10px",
            textAlign: "center",
          }}
        >
          Tell us what you're interested in
        </Text>

        {/* Content */}

        <Flex
          style={{
            width: "100%",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          {interests.content.map((interest, index) => {
            return (
              <Button
                onClick={() => {
                  setMetadata((prevState) => {
                    const copy = deepCopy(prevState);

                    if (!copy.interests) {
                      copy.interests = [];
                    }

                    const index = copy.interests?.indexOf(interest.id);

                    if (index == -1) {
                      copy.interests?.push(interest.id);
                    } else {
                      copy.interests?.splice(index, 1);
                    }

                    return copy;
                  });
                }}
                key={index}
                style={{
                  background:
                    metadata.interests?.indexOf(interest.id) == -1
                      ? token.colorBgContainerDisabled
                      : interest.color,

                  color:
                    metadata.interests?.indexOf(interest.id) != -1
                      ? token.colorWhite
                      : token.colorTextDisabled,
                }}
              >
                {interest.name}
              </Button>
            );
          })}
        </Flex>

        {/* EndContent */}

        <Button
          loading={isUpdating}
          style={{
            margin: token.marginMD,
            padding: token.paddingContentVerticalLG,
            width: "320px",
            marginTop: token.marginXXL + token.marginXL,
          }}
          type="primary"
          onClick={() => {
            if (!metadata.name) {
              return message.error("Name is required");
            }

            if (!metadata.interests || metadata.interests?.length < 3) {
              return message.error("Please select at least 3 interests");
            }

            if (!metadata.language) {
              return message.error("Language is required");
            }

            if (3 - metadata.interests?.length <= 0) {
              onComplete();
            }
          }}
        >
          <Text style={{ color: token.Button?.primaryColor }}>
            {isUpdating
              ? "Updating..."
              : 3 - metadata.interests?.length > 0
              ? "Pick " + (3 - metadata.interests?.length) + " more"
              : "Complete"}
          </Text>
        </Button>

        <Flex align="center" justify="space-between" style={{ width: "100%" }}>
          <div />

          <Flex align="center">
            {Array.from({ length: steps }).map((_, index) => {
              if (index > currentStep) {
                return (
                  <Button
                    disabled={isUpdating}
                    key={index}
                    size="small"
                    style={{
                      background: "transparent",
                      border: "none",
                      boxShadow: "none",
                    }}
                    onClick={() => setCurrentStep(index)}
                  >
                    <div
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: token.colorBgContainer,
                        border: `1px solid ${token.colorSplit}`,
                      }}
                    />
                  </Button>
                );
              }

              return (
                <Button
                  key={index}
                  size="small"
                  disabled={isUpdating}
                  style={{
                    background: "transparent",
                    border: "none",
                    boxShadow: "none",
                  }}
                  onClick={() => setCurrentStep(index)}
                >
                  <div
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: token.colorPrimary,
                    }}
                  />
                </Button>
              );
            })}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
